import { render } from "./ImportXmlSummary.vue?vue&type=template&id=204bbad6&scoped=true&ts=true"
import script from "./ImportXmlSummary.vue?vue&type=script&lang=ts"
export * from "./ImportXmlSummary.vue?vue&type=script&lang=ts"

import "./ImportXmlSummary.vue?vue&type=style&index=0&id=204bbad6&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204bbad6"]])

export default __exports__